<template>

  <!-- 个人信息 -->

  <el-dialog :visible.sync="visibleRole" append-to-body width="70%" :show-close="true" :before-close="closeModal">
    <!-- 校友 -->
    <div class="home-wrapss" v-if="userInfo.classify == 30">
      <section class="home-content-wrap">
        <div class="left">
          <div class="left-name">头像</div>
        </div>
        <div class="right">
          <div class="left-name">
            <img :src="userInfo.logo" alt="" class="logo-icon" />
          </div>
        </div>
        <div class="left">
          <div class="left-name">用户名</div>
        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.userName }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">性别</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.sex | filterSex }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">入学时间</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.birth }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">毕业时间</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.birth }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">班级</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.code4 }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">邮箱</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.mail }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">手机号</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.phone }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">所在院系</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.code1 | departmentFilter }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">所在专业</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.code2 | specializedFilter }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">所在班级</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.code4 }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">学历</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.code4 }}
          </div>
        </div>
      </section>

      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">工作单位</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.userPosition }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">职务</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.userPosition }}
          </div>
        </div>
      </section>

      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">所属地区</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.region }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">联系地址</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.region }}
          </div>
        </div>
      </section>

      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">电话</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.officePhone }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">备注</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.officePhone }}
          </div>
        </div>
      </section>
    </div>
    <!-- 在校学生/教职工 -->
    <div class="home-wrapss" v-else>
      <section class="home-content-wrap">
        <div class="left">
          <div class="left-name">头像</div>
        </div>
        <div class="right">
          <div class="left-name">
            <img :src="userInfo.logo" alt="" class="logo-icon" />
          </div>
        </div>
        <div class="left">
          <div class="left-name">用户名</div>
        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.userName }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">学号/工号</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.userId }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">账号状态</div>

        </div>
        <div class="right">
          <div class="left-name">
            正常
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">部门</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.codeName1 }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">手机号</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.phone }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">邮箱</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.mail }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">身份证号</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.certNo }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">状态</div>

        </div>
        <div class="right">
          <div class="left-name">
            <!-- {{ userInfo.status|filterStaus }} -->
          </div>
        </div>
        <div class="left">

          <div class="left-name">身份</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.classifyName }}
          </div>
        </div>
      </section>
      <section class="home-content-wrap">
        <div class="left">

          <div class="left-name">创建时间</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.registerTime | dateFormatFilter }}
          </div>
        </div>
        <div class="left">

          <div class="left-name">最新登录时间</div>

        </div>
        <div class="right">
          <div class="left-name">
            {{ userInfo.latestLoginTime | dateFormatFilter }}
          </div>
        </div>
      </section>
    </div>

  </el-dialog>
</template>
<script>
import homeHead from '../../component/homeHead.vue'
import { getMyUserInfo, changeAccountPwd } from '../../../../api/api.p'
import { dateFormat } from '../../../../libs/util'

export default {
  props: {
    visibleRole: {
      type: Boolean,
      default: false
    },
  },
  watch: {

  },
  data () {
    return {
      modelPass: {
        oldPass: '',
        newPass: '',
        affirmPass: '',
      },
      userInfo: {},
      internalVisible: false, // 使用 prop 的值初始化本地数据属性
    }
  },
  filters: {
    dateFormatFilter (val) {
      let str = ''
      str = val
        ? val.toString().length < 13
          ? dateFormat('yyyy-MM-dd hh:mm:ss', val + '000')
          : dateFormat('yyyy-MM-dd hh:mm:ss', val)
        : ''
      return str
    },
    // 状态
    filterStaus (val) {
      let str = ''
      str = val == 0 ? '教职工' : val == 1 ? '学生' : '其他'
      return str
    },
    // 身份
    filterClass (val) {
      let str = ''
      switch (val) {
        case 0:
          str = '教职工'
          break
        case 10:
          str = '本专科学生'
          break
        case 20:
          str = '研究生'
          break
        case 30:
          str = '校友'
          break
        case 99:
          str = '其他'
          break
      }
      return str
    },
    // 性别
    filterSex (val) {
      let str = ''
      str = val == 0 ? '女' : val == 1 ? '男' : '未知'
      return str
    },
    // 院系
    departmentFilter (val) {
      let str = ''
      switch (val) {
        case 0:
          str = '教职工'
          break
        case 10:
          str = '本专科学生'
          break
        case 20:
          str = '研究生'
          break
        case 30:
          str = '校友'
          break
        case 99:
          str = '其他'
          break
      }
      return str
    },
    // 专业
    specializedFilter (val) {
      let str = ''
      switch (val) {
        case 0:
          str = '教职工'
          break
        case 10:
          str = '本专科学生'
          break
        case 20:
          str = '研究生'
          break
        case 30:
          str = '校友'
          break
        case 99:
          str = '其他'
          break
      }
      return str
    },
  },
  components: {
    homeHead,
  },
  created () {
  },
  mounted () {

  },
  methods: {
    closeModal () {
      this.userInfo = {};
      this.$emit('closes');
    },
    init () {

      this.getMyUserInfo()
    },
    getMyUserInfo () {
      getMyUserInfo()
        .then((res) => {
          if (res.meta.code == 0) {
            this.userInfo = res.data
            // window.sessionStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
            // localStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
          } else {
            this.$toast(res.meta.message)
          }
        })
        .catch((err) => {
          this.$toast(err.meta.message)
        })
    },
  },
}
</script>

<style lang="less" scoped>
@import './../../../../common/homeInfo';

.home-wrapss {
  width: 100%;
  border: 1px solid #d9d9d9;
  .home-content-wrap:last-child {
    border-bottom: none;
  }
  .home-content-wrap {
    width: 100%;
    display: flex;

    // justify-content: left;
    // flex-wrap: wrap;

    border-bottom: 1px solid #d9d9d9;

    .left {
      padding: 12px 0;
      width: 120px;
      background: #f8f8fa;
      border-right: 1px solid #d9d9d9;
      text-align: center;
      display: flex;
      align-items: center; /* 垂直居中 */
      justify-content: center; /* 水平居中 */
    }
    .left-name {
      width: 100%;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #202020;
    }
    .right:last-child {
      border-right: none;
    }
    .right {
      padding: 12px 0;
      flex: 1;
      border-right: 1px solid #d9d9d9;
      text-align: center;
      display: flex;
      align-items: center; /* 垂直居中 */
      justify-content: center; /* 水平居中 */
    }
  }
}
.logo-icon {
  width: 40px;
  height: 40px;
}
</style>


